module.exports = __webpack_public_path__ + "img/sec-card2.c2a97aa.png";